module.exports = __webpack_public_path__ + "static/media/banner_home.1f44f6b6.png";